import { useState } from "react";
import { fieldNames } from "../../components/PIForm/Steps/step3/utils";

const {
  BIRTH_CITY,
  BIRTH_COUNTRY,
  CITY,
  COUNTRY_CODE,
  COUNTRY,
  CITY_VILLAGE,
  APARTMENT_NUMBER,
  HOME_NUMBER,
  STREET,
  DUAL_CITIZENSHIP,
  IS_ACTUAL_ADDRESS,
  LEGAL_ADDRESS,
  ACTUAL_ADDRESS,
  VILLAGE,
  SEX,
  DUAL_CITIZENSHIP_COUNTRY,
} = fieldNames;

const initAddress = {
  [COUNTRY]: "",
  [CITY]: "",
  [STREET]: "",
  [CITY_VILLAGE]: "",
  [HOME_NUMBER]: "",
  [APARTMENT_NUMBER]: "",
  [VILLAGE]: "",
};

const initState = {
  [BIRTH_COUNTRY]: "",
  [BIRTH_CITY]: "",
  [COUNTRY_CODE]: "",
  [DUAL_CITIZENSHIP_COUNTRY]: "",
  [DUAL_CITIZENSHIP]: false,
  [IS_ACTUAL_ADDRESS]: false,
  [SEX]: "",
  [LEGAL_ADDRESS]: { ...initAddress },
  [ACTUAL_ADDRESS]: { ...initAddress },
};

function useStepThreeValues() {
  const [stepThreeValues, setStepThreeValues] = useState(initState);
  return { stepThreeValues, setStepThreeValues };
}

export default useStepThreeValues;
